import Vue from 'vue';
import VueRouter from 'vue-router';
import Navigation from '@/components/Navigation.vue'
import Main from '@/views/Main.vue'
import NotFound from '@/views/NotFound.vue'
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Main',
    components: {
        default: Main,
        navigation: Navigation
    },
    meta: {
      title: 'ÖAMTC Routenplaner'
    }
  },
  // POI related
  {
    path: '/poi/:poicategory',
    name: 'POI Category',
    components: {
        default: Main,
        navigation: Navigation
    },
    meta: {
      title: 'ÖAMTC Routenplaner'
    }
  },
  {
    path: '/poi/:poicategory/:poiid',
    name: 'POI Detail',
    components: {
        default: Main,
        navigation: Navigation
    },
    meta: {
      title: 'ÖAMTC Routenplaner'
    }
  },
  // ROUTE related
  {
    path: '/route',
    name: 'Route',
    components: {
        default: Main,
        navigation: Navigation
    },
    meta: {
      title: 'ÖAMTC Routenplaner'
    }
  },
  { path: '/routenplaner/auth' },
  { path: '/routenplaner/auth-ntlm' },
  { path: '/routenplaner/auth-internal' },
  { path: '/routenplaner/config' },
  { path: '/routenplaner/api' },
  { path: '/routenplaner/user' },
  { path: '*',
    components: {
      default: NotFound,
      navigation: Navigation
    },
    meta: {
      title: 'Seite nicht gefunden – ÖAMTC Routenplaner'
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next()
});

export default router;
